import React from 'react'
import loungeLocationPages from '../../../../config/loungeLocationPages'
import ProductSelect from './productSelect.jsx'

const ParkingSelect = ({id, label = 'Select your airport lounge'}) => (
  <ProductSelect id={id} label={label} options={loungeLocationPages} />
)

export default ParkingSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/loungeselect.jsx